/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FamilyPoolInvitationCreateRequest
 */
export interface FamilyPoolInvitationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolInvitationCreateRequest
     */
    inviteeEmail: string;
}

/**
 * Check if a given object implements the FamilyPoolInvitationCreateRequest interface.
 */
export function instanceOfFamilyPoolInvitationCreateRequest(value: object): value is FamilyPoolInvitationCreateRequest {
    if (!('inviteeEmail' in value) || value['inviteeEmail'] === undefined) return false;
    return true;
}

export function FamilyPoolInvitationCreateRequestFromJSON(json: any): FamilyPoolInvitationCreateRequest {
    return FamilyPoolInvitationCreateRequestFromJSONTyped(json, false);
}

export function FamilyPoolInvitationCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyPoolInvitationCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteeEmail': json['invitee_email'],
    };
}

export function FamilyPoolInvitationCreateRequestToJSON(json: any): FamilyPoolInvitationCreateRequest {
    return FamilyPoolInvitationCreateRequestToJSONTyped(json, false);
}

export function FamilyPoolInvitationCreateRequestToJSONTyped(value?: FamilyPoolInvitationCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitee_email': value['inviteeEmail'],
    };
}

